var exports = {
  "g": "AccentColorPicker.module__errorMessage___TFk0RU",
};

module.exports = exports;
